<template>
    <div class="chat-message media">
        <figure class="media-left" v-if="!hideAvatars && !messageSenderEquals(currentUserAccount)">
            <avatar :account="messageSenderEquals(sender) ? sender :addressee" :size="40" round />
        </figure>

        <div class="media-content">
            <div class="inner-message" :class="{ 'is-sender': messageSenderEquals(currentUserAccount) }">
                <p class="name is-small">{{messageSenderEquals(sender) ? sender.name : addressee.name}}</p>

                <div class="textbox">
                    <p>{{message.content.trim()}}</p>
                </div>

                <p class="is-size-7">
                    <b-tooltip v-if="message.sent_at"
                               :label="message.sent_at | formatShortDateTime"
                               position="is-bottom"
                               type="is-dark">
                        &nbsp;{{ message.sent_at | formatTimeAgo }}
                    </b-tooltip>

                    <b-tooltip v-if="message.read_at && isLast && messageSenderEquals(currentUserAccount)"
                               :label="message.read_at | formatShortDateTime"
                               position="is-bottom"
                               type="is-dark">
                        &nbsp;<b-icon size="is-small" type="is-primary" icon="eye-check" />
                    </b-tooltip>

                </p>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../../global/styles/variables';

    .chat-message {
        &+ .chat-message {
            border-top: none;
            margin-top: 0;
            padding-top: 0;
        }

        .media-left {
            margin-top: 25px;
        }

        .inner-message {
            max-width: 75%;
            margin-bottom: 1.5rem;

            &.is-sender {
                margin-left: auto;

                .textbox {
                    color: $primary-invert;
                    background-color: $primary;
                }
            }

            .name {
                margin-bottom: 2px;
            }

            .textbox {
                background-color: whitesmoke;
                border-radius: 4px;
                padding: 1rem;
                white-space: pre-wrap;
            }
        }
    }
</style>

<script>
    import Avatar from '@/taskflex/users/components/Avatar';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            message: {
                required: true,
                type: Object,
            },

            addressee: {
                required: true,
                type: Object,
            },

            sender: {
                required: true,
                type: Object,
            },

            hideAvatars: {
                required: false,
                default: false,
            },

            isLast: {
                required: true,
                default: false,
            },
        },

        computed: {
            ...mapGetters('auth', [
                'currentUserAccount',
            ]),
        },

        methods: {
            messageSenderEquals(account) {
                return this.message.sender.id === account.id;
            },
        },

        components: {
            Avatar,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Messages/Message.vue